export const INITIAL = {
	ACTION: {
		type: '',
		data: {},
	},
	MODAL: {
		content: '',
		data: {}
	},
	VALUES: {
		type: 'Personagem',
		name: '',
		symbol: '',
		color: '#000000',
	},
	LIST: {
		name: '',
		description: '',
		horizontal: 0,
		vertical: 0,
		board: []
	},
}